module.exports = "/logo-horizontal-ba2c9c648227efbdb3f85a2c40bc1711.svg";